var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.4,
    fill: "#010203",
    stroke: "white",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1616 6.52582L3.55554 6.52558L3.55579 8.06115C3.55579 8.06115 3.55554 8.82907 3.55554 9.59649C3.55554 10.3639 4.32322 10.3639 4.32322 10.3639H7.92928V8.82882V7.29324C7.92928 6.52558 7.1616 6.52582 7.1616 6.52582Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4649 7.29324V9.59649L11.2326 10.3642C11.2326 10.3642 12.4444 11.5553 12.4444 10.6673V9.59649V7.29324V6.22182C12.4444 5.33326 11.5555 6.22206 11.5555 6.22206L10.4649 7.29324Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1616 6.52582L3.55554 6.52558L3.55579 8.06115C3.55579 8.06115 3.55554 8.82907 3.55554 9.59649C3.55554 10.3639 4.32322 10.3639 4.32322 10.3639H7.92928V8.82882V7.29324C7.92928 6.52558 7.1616 6.52582 7.1616 6.52582Z",
    stroke: "white",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4649 7.29324V9.59649L11.2326 10.3642C11.2326 10.3642 12.4444 11.5553 12.4444 10.6673V9.59649V7.29324V6.22182C12.4444 5.33326 11.5555 6.22206 11.5555 6.22206L10.4649 7.29324Z",
    stroke: "white",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.7ba19f2f0d424b2f655592bfa195497b.svg";
export { ForwardRef as ReactComponent };